import * as client from "openid-client";
import * as jose from "jose";

const tokenKey = "tokens";

async function makeConfig() {
  return await client.discovery(
    new URL(
      "https://sso.spohr.at/realms/main/.well-known/openid-configuration",
    ),
    "hydra-mail",
  );
}
async function startAuthentication() {
  const config = await makeConfig();

  const parameters = {
    redirect_uri: window.location.toString()
  };

  const redirectTo = client.buildAuthorizationUrl(config, parameters);

  window.location.replace(redirectTo);
}

async function handleAuthProviderAnswer(url: URL) {
  const config = await makeConfig();

  let tokens = await client.authorizationCodeGrant(config, url);

  window.localStorage.setItem(tokenKey, JSON.stringify(tokens));

  url.search = "";
  window.location.replace(url);
}

function isReturningFromAuthProvider(url: URL) {
  return url.search !== "";
}

export async function refreshIfExpired(
  tokens: client.TokenEndpointResponse & client.TokenEndpointResponseHelpers,
) {
  const accessToken = jose.decodeJwt(tokens.access_token);

  if (accessToken.exp && accessToken.exp > Date.now() / 1000 + 5) {
    return tokens.access_token;
  }

  console.log("Token expired.");
  const refreshToken = tokens.refresh_token;

  if (!refreshToken) {
    await startAuthentication();
    return;
  }

  try {
    const config = await makeConfig();

    const newTokens = await client.refreshTokenGrant(config, refreshToken);

    window.localStorage.setItem(tokenKey, JSON.stringify(newTokens));
    return newTokens.access_token
  } catch (error: any) {
    console.error("Error refreshing access token: ", error.message);
    await startAuthentication();
  }
}

export async function start() {
  const currentUrl = new URL(window.location.toString());

  if (isReturningFromAuthProvider(currentUrl)) {
    await handleAuthProviderAnswer(currentUrl);
    return;
  }

  await getAccessToken()
}

export async function getAccessToken() {
  const storedToken = window.localStorage.getItem(tokenKey);
  const currentToken = storedToken && JSON.parse(storedToken);

  if (!currentToken) {
    await startAuthentication();
    return;
  }

  return await refreshIfExpired(currentToken);
}
